import { INTERACTION_ROLE_LABEL } from '../../constants';

export function getRoleOptions() {
  return Object.entries(INTERACTION_ROLE_LABEL).map(([value, label]) => ({
    key: value,
    text: label,
    value,
  }));
}
